var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34578"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 167",
    y: 0.664062,
    width: 14,
    height: 3.07576,
    fill: "#00AA40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 168",
    y: 6.81836,
    width: 14,
    height: 3.07576,
    fill: "#FA0305"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 169",
    y: 3.73828,
    width: 14,
    height: 3.07576,
    fill: "#F8FFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 104",
    cx: 6.99964,
    cy: 5.27675,
    rx: 0.636364,
    ry: 0.768939,
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag_icon.465d307b7583754bd3f8a499d2108099.svg";
export { ForwardRef as ReactComponent };